import React from 'react'
import { Column } from 'primereact/column'
import YearBodyTemplate from './YearBodyTemplate'
import YearEditor from './YearEditor'
import NumericFilterTemplate from '../Filters/NumericFilterTemplate'
import { createFieldChangedChecker } from '../utils/createFieldChangedChecker'

const YearColumn = ({ title, mapsToField, filter, sortable, editable, isFieldChanged, isFieldChangedOverride, validationErrors, originalData }) => {
    const filterAttributes = {
        filter,
        filterPlaceholder: `Search by  ${title}`,
        required: !!filter,
        disabled: !filter
    }
    const sortAttributes = {
        sortable,
        required: !!sortable,
        disabled: !sortable
    }

    const checkFieldChanged = createFieldChangedChecker({
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isFieldChanged,
        mapsToField,
        originalData
    })

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            dataType="numeric"
            body={(rowData) => (
                <span className={checkFieldChanged(rowData) ? 'changed-field' : ''}>
                    <YearBodyTemplate rowData={rowData} field={mapsToField} />
                </span>
            )}
            editor={editable ? (options) => <YearEditor options={options} validationErrors={validationErrors} /> : null}
            filterElement={(options) => <NumericFilterTemplate options={options} field={mapsToField} />}
            {...filterAttributes}/>
    )
}

export default YearColumn
